export const BUILD_VERSION = '1790097245';
